export const headerStyles = {
    backgroundColor: 'var(--table-background-color)',
    color: 'white',
    borderBottom: '1px solid #ccc'
};


export const nestedHeaderStyles = {
    backgroundColor: '#27272A',
    color: '#D1D5DB',
    borderBottom: '1px solid #3F3F46',
    borderTop: '1px solid #3F3F46'
};

export const hideHeaderStyles = {
    display: 'none !important'
};

export const getRowStyle = () => {
    return { backgroundColor: '#18181B', color: 'white', borderColor: '#D8D8D8 !important'} // Ensure text is readable
};